import {Button, Grid, TextField} from "@mui/material";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";
import {useMemo, useState} from "react";
import {CreateRefLinkDto} from "@components/solicitacoes/itens/dto/CreateRefLinkDto.ts";
import {IOperationResponse} from "@localization/siteMap/siteMapInterfaces.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";

interface CreateRefLinkComponentProps {
    itemId: number,
    orcamentoId?: number,
    onCreate?: (v: IOperationResponse) => void,
}

export function CreateRefLinkComponent(props: CreateRefLinkComponentProps) {
    const {createReferenciaItem} = useSolicitacao()
    const {createAlertFromResponse} = useAlert()
    const [value, setValue] = useState<CreateRefLinkDto>({
        idItem: props.itemId,
        idOrcamento: props.orcamentoId,
        descricao: '',
        url: '',
    })

    const urlValid = useMemo(() => {
        try {
            const url = new URL(value.url);
            return url.protocol === 'http:' || url.protocol === 'https:';
        } catch (error) {
            return false;
        }
    }, [value.url]);


    return (<Grid>
            <TextField value={value.descricao} label={'Descrição'}
                       onChange={(e) => setValue({...value, descricao: e.target.value})}/>
            <TextField value={value.url} label={'Link'}
                       error={!urlValid}
                       helperText={!urlValid ? 'O link deve ser uma URL válida' : ''}
                       onChange={(e) => setValue({...value, url: e.target.value})}/>
            <Button onClick={() => {
                createReferenciaItem(value).then(x => {
                    createAlertFromResponse(x)
                    if (x.status == 'Success') {
                        setValue({
                            idItem: props.itemId,
                            idOrcamento: props.orcamentoId,
                            descricao: '',
                            url: '',
                        })
                        if (props.onCreate != null)
                            props.onCreate(x)
                    }
                })
            }}>Enviar</Button>
        </Grid>
    )
}